export default __webpack_public_path__ + "static/my-way~EgcihScs-e1237b0a5150fdca98d8d8c931e04f60.png";